import { useRouter } from "next/router";
import { useSegmentCallbackV2 } from "../../src/segment";

const ANALYTICS_PREFIX = "OB20";

export const usePageNavigation = <Pages extends readonly string[]>(
  pages: Pages
) => {
  type Page = Pages[number];

  const router = useRouter();
  const segmentCallback = useSegmentCallbackV2();

  const createEventLogger = (message: string) => () =>
    segmentCallback(`${ANALYTICS_PREFIX} - ${message}`);

  const navigateToPage = (page: Page) =>
    router.push(`/get-started?page=${page}`);

  const currentPage: Page =
    router.query.page &&
    typeof router.query.page === "string" &&
    pages.includes(router.query.page)
      ? router.query.page
      : pages[0];

  const currentPageIndex = pages.indexOf(currentPage);

  const navigatePrevious = () => {
    const newPage = pages[Math.max(pages.indexOf(currentPage) - 1, 0)];

    navigateToPage(newPage);
  };

  const navigateNext = () => {
    const newPage =
      pages[Math.min(pages.indexOf(currentPage) + 1, pages.length - 1)];

    createEventLogger(`${currentPage}: Complete`)();

    navigateToPage(newPage);
  };

  const createPageLogger = (prefix: Pages[number]) => (message: string) => {
    createEventLogger(`${prefix}: ${message}`)();
  };

  return {
    currentPage,
    currentPageIndex,
    navigatePrevious,
    navigateNext,
    createPageLogger,
  };
};
